import { render, staticRenderFns } from "./GameScore.vue?vue&type=template&id=8366baf6&scoped=true&"
import script from "./GameScore.vue?vue&type=script&lang=js&"
export * from "./GameScore.vue?vue&type=script&lang=js&"
import style0 from "./GameScore.vue?vue&type=style&index=0&id=8366baf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8366baf6",
  null
  
)

export default component.exports